<!--
Collection button with preview images that links to the collection page.
Takes a collection object or collection ID as a prop.
-->
<template>
  <ImageTileButton
    :title="name ?? 'Collection'"
    :subtitle="itemCountText"
    :images="previewImageUrls"
    :image-count="imageCount"
    :to="routeLocation"
    @click="emit('click', $event)"/>
</template>

<script setup>
import { computed, toValue } from 'vue'
import useCollection, { useCollectionById } from '@/composables/collection.js'
import ImageTileButton from '@/components/global/ImageTileButton.vue'

const props = defineProps({
  collection: {
    type: [Object, String],
    required: true
  }
})

const composable = typeof props.collection === 'string' ? useCollectionById : useCollection
const { name, itemCountText, previewImageUrls, routeLocation } = composable(() => props.collection)

// Use image-count="1" only when there's a bannerImageUrl (Armoire sections)
// Otherwise use image-count="2" to preserve proper aspect ratio for single images
const imageCount = computed(() => {
  const collection = toValue(props.collection)
  return collection?.bannerImageUrl ? 1 : 2
})

const emit = defineEmits({
  click: (event) => event instanceof MouseEvent
})
</script>
